module.exports = __webpack_public_path__ + "static/media/softex.765df3d9.png";